type ScrollBox = {
    scrollTop: number
    getBoundingClientRect: () => Pick<DOMRect, 'top' | 'bottom'>
}

type ScrollItem = {
    getBoundingClientRect: () => Pick<DOMRect, 'top' | 'bottom'>
}

export function keepActionCommandItemVisible(
    list: ScrollBox | null,
    selectedItem: ScrollItem | null,
) {
    if (!list || !selectedItem) return

    const listRect = list.getBoundingClientRect()
    const itemRect = selectedItem.getBoundingClientRect()

    if (itemRect.top < listRect.top) {
        list.scrollTop += itemRect.top - listRect.top
    } else if (itemRect.bottom > listRect.bottom) {
        list.scrollTop += itemRect.bottom - listRect.bottom
    }
}
